import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComputPage from '@/components/ComputePage.vue';
import ComputeWizardFriction from '@/components/ComputeWizard/ComputeWizardFriction.vue';
import { RoutePath } from '@/enums/Router';

export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeFrictionPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputPage, {
    class: "compute-friction-page",
    "prev-url": _unref(RoutePath).COMPUTE_STEP_SURFACE,
    "next-url": _unref(RoutePath).COMPUTE_STEP_QUALITY,
    title: _ctx.$t('home.steps.friction.label'),
    "current-step": 3
  }, {
    default: _withCtx(() => [
      _createVNode(ComputeWizardFriction)
    ]),
    _: 1
  }, 8, ["prev-url", "next-url", "title"]))
}
}

})